import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
// import {TableComp} from 'sz-react-utils'
import TableComp from '../../../components/_utils/table'

import moment from 'moment'
import {Card, DatePicker} from 'antd'
import Request from '../../../request'
import {connect} from 'react-redux'

const { RangePicker } = DatePicker

//let itemPage = 0
//let itemCount = 20


class AllSms extends Component {

  state = {
    count: 0,
    time: {
      key: 'time',
      from: null,
      to: null
    }

  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }


  apiRequest = (params, columns) => {
    return new Promise(async resolve => {

      // if (params.page && params.count) {
      //   itemPage = params.page && params.page - 1
      //   itemCount = params.count && params.count
      // }


      // params.count = 200

      if (!params.sortField) {
        params.sortField = 'date'
        params.sortOrder = 'descend'
      }

      let data = await Request.loadAllSms({
        ...params,
        regExFilters: ['message', 'mobile'],
        sortedDate: this.state && this.state.time

      })
      delete data.error
      delete data.type

      this.setState({ count: data.total })
      resolve(data)
    })
  }

  chooseRangerPicker = (date, dateString) => {
    this.setState({
      time: {
        key: 'time',
        from: date[0],
        to: date[1]
      }
    }, () => {
      console.log(this.state.time, '@@@@@@@@@@@@@@@@@@@')

    })


    if (date[0] === undefined) {
      setTimeout(() => {
        this.reload()
      }, 500)
    }
  }
  reload = () => {
    this.table.current.reload()
  }

  async componentDidMount() {

  }

  render() {
    const columns = [
      // {
      //   title: 'Sr No.',
      //   key: 'sr',
      //   dataIndex: 'sr',
      //   render: (val, record, key) => {
      //     return <div>{itemPage * itemCount + key + 1}</div>
      //   }
      // },
      // {
      //   title: 'Student Details',
      //   key: 'studentId',
      //   dataIndex: 'studentId',
      //   render: (val, record) => {
      //     return <React.Fragment>
      //       <Tooltip title="Click To View Details">
      //         <a className={styles.btn} target={'_blank'}
      //            href={`/inquiry/studentProfileDetails?id=${val && val._id}`}
      //         >{val && val.studentName}</a>
      //       </Tooltip>
      //
      //       <div>
      //
      //         <div>{val ? val.mobile : ''}</div>
      //         <div>{val ? val.email : ''}</div>
      //         <div>{val ? val.gender : ''}</div>
      //       </div>
      //     </React.Fragment>
      //
      //
      //   }
      // },
      {
        title: 'Message',
        key: 'message',
        dataIndex: 'message',
        searchTextName: 'message'
      },
      {
        title: 'Mobile',
        key: 'mobile',
        dataIndex: 'mobile',
        searchTextName: 'mobile'

      },
      {
        title: 'Date',
        key: 'date',
        dataIndex: 'date',

        render: (val, record) => {
          return (<div> {moment(val).format('DD-MMM-YYYY hh:mm:A')} </div>)

        }

      }
      // {
      //   title: 'Details',
      //   key: 'details',
      //   dataIndex: 'details',
      //   searchTextName: 'details',
      //   render: (val, record) => {
      //     return <div>{val ? S(val).stripTags().s : null}</div>
      //   }
      // },


    ]
    return (
      <PageHeaderWrapper title={` All Communication SMS : ${this.state.count} `}>
        <Card bordered={true}>
          <h4>FILTER BY DATE</h4>
          <RangePicker
            showTime={{ format: 'HH:mm' }}
            defaultValue={[moment().startOf('day'), moment().endOf('day')]}
            format="YYYY-MM-DD HH:mm"
            placeholder={['Start Time', 'End Time']}
            onChange={this.chooseRangerPicker}
            onOk={this.reload}
          />
          <TableComp
            showSelector={true}
            columns={columns}
            ref={this.table}
            apiRequest={params => this.apiRequest(params, columns)}
            //extraProps={{ scroll: { x: 1000 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 20,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Card>
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllSms)
